export const NOTIFICATIONS_QUERY_KEYS = {
  LAST_SEEN_NOTIFICATION: ["last-seen-notification"],
} as const;
